import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import UiAddressFormElements from '@yoweb/ui/components/AddressFormElements';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";

var AddressFormElements = function AddressFormElements(props) {
  var _useExternalConfig = useExternalConfig(),
      places = _useExternalConfig.places;

  return /*#__PURE__*/_jsx(UiAddressFormElements, _objectSpread({
    placesApiKey: places.publicKey
  }, props));
};

export default AddressFormElements;